/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="m16.4472 16.8008-.3275-.3275-.3515.3015C14.1502 18.1622 12.0486 19 9.75 19 4.6414 19 .5 14.8586.5 9.75S4.6414.5 9.75.5 19 4.6414 19 9.75c0 2.2986-.8378 4.4002-2.2252 6.0182l-.3015.3515.3275.3275 6.626 6.626a.2501.2501 0 0 1-.3047.3918l-.0647-.054-6.6102-6.6102ZM18.5 9.75C18.5 4.9175 14.5825 1 9.75 1S1 4.9175 1 9.75s3.9175 8.75 8.75 8.75 8.75-3.9175 8.75-8.75Z"
  />,
  'Search'
);
